export { default } from './index.vue';



// WEBPACK FOOTER //
// ./packages/wxc-tab-bar/index.js